import type { TemplateRef } from '@angular/core';
import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';

import { GroupedOpenQuestionAnswer, OpenQuestionAnswer } from '@recruitee/candidate-types';
import { CollapseState } from '@recruitee/common';

import type { DecoratedGroupedOpenQuestionAnswers } from '../candidate-questions.interfaces';
import type { CandidateQuestionsModuleTranslations } from '../translations';
import { CandidateQuestionsTranslations } from '../translations';
import { QuestionsMode } from '../types';
import { CandidateQuestionsItemComponent } from './candidate-questions-item/candidate-questions-item.component';

@Component({
  selector: 'rt-candidate-questions-result',
  templateUrl: './candidate-questions-result.component.html',
  styleUrls: ['./candidate-questions-result.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CandidateQuestionsItemComponent],
})
export class CandidateQuestionsResultComponent {
  public readonly QuestionsMode: typeof QuestionsMode = QuestionsMode;

  @Input() public visibilityTplRef: TemplateRef<any>;
  @Input({
    transform: (
      value: GroupedOpenQuestionAnswer,
    ): GroupedOpenQuestionAnswer & { decoratedStatus: string } => ({
      ...value,
      decoratedStatus: value.offer?.status ? value.offer.status : 'archived',
    }),
  })
  public data: GroupedOpenQuestionAnswer;
  @Input() public canManageCandidates: boolean = false;
  @Input() public hasBooleanFlagAnswers: boolean = false;
  @Input() public mode: QuestionsMode;

  public CollapseState: typeof CollapseState = CollapseState;

  constructor(
    @Inject(CandidateQuestionsTranslations)
    public translations: CandidateQuestionsModuleTranslations,
  ) {}

  public getGroupTitle(group: DecoratedGroupedOpenQuestionAnswers): string {
    const offerTitle = group.question.offer && group.question.offer.title;
    return offerTitle || '';
  }

  public hasTitleGroup(group: DecoratedGroupedOpenQuestionAnswers): boolean {
    return !!this.getGroupTitle(group);
  }

  public answersTrackBy(index: number, answer: OpenQuestionAnswer): number {
    return answer.id;
  }
}
